"use strict";
var __importDefault = (this && this.__importDefault) || function (mod) {
    return (mod && mod.__esModule) ? mod : { "default": mod };
};
Object.defineProperty(exports, "__esModule", { value: true });
const jsx_runtime_1 = require("react/jsx-runtime");
const ArrowRightAlt_1 = __importDefault(require("@mui/icons-material/ArrowRightAlt"));
const material_1 = require("@mui/material");
const react_query_1 = require("@tanstack/react-query");
const react_1 = require("react");
const react_router_1 = require("react-router");
const appConstants_1 = require("../../../../constants/appConstants");
const strings_1 = require("../../../../constants/strings");
const uiConstants_1 = require("../../../../constants/uiConstants");
const companyQuery_1 = require("../../../../queries/companyQuery");
const paymentQuery_1 = require("../../../../queries/paymentQuery");
const teamQuery_1 = require("../../../../queries/teamQuery");
const userQuery_1 = require("../../../../queries/userQuery");
const pageLoader_1 = __importDefault(require("../../../../router/loaders/pageLoader"));
const Root_1 = require("../../../../router/Root");
const userSelectors_1 = require("../../../../selectors/userSelectors");
const zustandStore_1 = require("../../../../zustandStore");
const simpleButton_1 = __importDefault(require("../../../atoms/button/simpleButton"));
const enrollCardAside_1 = __importDefault(require("../../../organisms/createTeamModal/enrollCardAside"));
const drawerAside_1 = __importDefault(require("../../../organisms/drawerAside"));
const footer_1 = __importDefault(require("../../../organisms/footer"));
const cardsTable_1 = __importDefault(require("../../companySettings/cards/cardsTable"));
const TeamCardDetailsAside_1 = require("./TeamCardDetailsAside");
const TeamSettingsCardsTemplate = ({ cardSource = {}, cardAsides = {}, cardOptions = [], toggleCard = () => ({}), onRemoveCard = () => ({}), onSelectTeams = () => ({}), setCardAsides = () => ({}), includeRemoveCard = false, saveConfirmAside = () => ({}), submitCardSourceData = () => ({}), toggleCardDetailsAside = () => ({}), linkCardSourceToTeam, includeSelectTeams, }) => {
    const { setFooterButtons, setIsAddSourceCardOpen, setIsSelectCardSourceOpen, setIsCardSourceDetailOpen } = (0, zustandStore_1.useZustand)();
    const initialData = (0, react_router_1.useLoaderData)();
    const { data: teamId } = (0, react_query_1.useQuery)({
        ...(0, teamQuery_1.selectedTeamIdQuery)('selectedTeamID'),
        initialData: initialData.teamId,
    });
    const { data: userData } = (0, react_query_1.useQuery)({
        ...userQuery_1.userQuery,
        initialData: initialData.userData,
    });
    const { data: companyPropertiesData } = (0, react_query_1.useQuery)({
        ...(0, companyQuery_1.companyPropertiesQuery)(userData?.companyAccountId, { cardprovider: 'tsgo-cardprovider' }),
        initialData: initialData.companyProperties,
    });
    const isHsbcCardProvider = companyPropertiesData?.cardprovider === 'HSBC';
    const isUserTeamAdmin = (0, userSelectors_1.isTeamAdmin)(userData?.roles || []);
    const selectCardSourceAside = (0, zustandStore_1.useZustand)(state => state.aside.selectCardSource);
    const cardSourceId = (0, zustandStore_1.useZustand)(state => state.payment.cardSourceId);
    const { refetch: refetchGetCardSource } = (0, paymentQuery_1.useGetCardSourceQuery)({
        cardSourceId: cardSourceId || '',
        includeCardHolder: true,
        teamId: '',
    });
    const { data: companyCards } = (0, paymentQuery_1.useGetCompanyCardSourcesQuery)({
        ...paymentQuery_1.paymentParams,
        isEnabled: Boolean(teamId?.[0]),
    });
    const { data: teamCards } = (0, paymentQuery_1.useGetTeamCardSourcesQuery)({
        ...paymentQuery_1.paymentParams,
        teamId: teamId?.[0] || '',
        isEnabled: Boolean(teamId?.[0]),
    });
    const uniqueCompanyCards = companyCards?.filter(companyCard => {
        return !teamCards?.some(teamCard => teamCard.id === companyCard.id);
    });
    (0, react_1.useEffect)(() => {
        if (cardSourceId) {
            void refetchGetCardSource();
        }
    }, [cardSourceId]);
    (0, react_1.useEffect)(() => {
        if (isUserTeamAdmin && isHsbcCardProvider) {
            setFooterButtons([]);
        }
        else {
            setFooterButtons([
                {
                    id: 'addSourceCard',
                    dataTestId: 'addSourceCard-btn',
                    label: globalThis.cardProvider.IS_HSBC_PROVIDER_SETUP
                        ? strings_1.teamSettingsCardStrings.ADD_PHYSICAL_CARD
                        : strings_1.teamSettingsCardStrings.ADD_SOURCE_CARD,
                    color: uiConstants_1.UI_BUTTON_PRIMARY,
                    onclick: () => setIsSelectCardSourceOpen(true),
                },
            ]);
        }
    }, [isHsbcCardProvider, isUserTeamAdmin]);
    const renderSelectCardSource = () => {
        return ((0, jsx_runtime_1.jsxs)(jsx_runtime_1.Fragment, { children: [(0, jsx_runtime_1.jsx)(material_1.Typography, { variant: "body1", children: globalThis.cardProvider.IS_HSBC_PROVIDER_SETUP
                        ? strings_1.cardDetailStrings.HSBC_ADD_CARD_SOURCE_INSTRUCTIONS_TEXT
                        : strings_1.cardDetailStrings.ADD_CARD_SOURCE_INSTRUCTIONS_TEXT }), (0, jsx_runtime_1.jsxs)(material_1.MenuList, { children: [uniqueCompanyCards?.map(entry => ((0, jsx_runtime_1.jsx)(material_1.MenuItem, { onClick: () => linkCardSourceToTeam(entry.id), disableGutters: true, children: (0, jsx_runtime_1.jsx)(material_1.Typography, { variant: "button", style: { paddingRight: 0 }, children: `${entry.name} (${entry.lastDigits})` }) }, entry.id))), (0, jsx_runtime_1.jsx)(material_1.MenuItem, { onClick: event => {
                                event.preventDefault();
                                setIsAddSourceCardOpen(true);
                            }, disableGutters: true, children: (0, jsx_runtime_1.jsx)(material_1.Grid, { container: true, children: (0, jsx_runtime_1.jsxs)(material_1.Grid, { size: 12, children: [strings_1.cardDetailStrings.ENROLL_NEW_CARD_BUTTON_TEXT, (0, jsx_runtime_1.jsx)(ArrowRightAlt_1.default, { sx: { float: 'right' } })] }) }) })] })] }));
    };
    const footerButtons = ((0, jsx_runtime_1.jsx)(simpleButton_1.default, { dataTestId: "cancel-btn", color: uiConstants_1.UI_BUTTON_SECONDARY, style: { marginTop: 'auto', marginBottom: '10px', width: '100%' }, label: strings_1.cardDetailStrings.CANCEL_BUTTON_TEXT, onClick: () => {
            setIsCardSourceDetailOpen({ isOpen: false, cardSourceId: '' });
            setIsAddSourceCardOpen(false);
            setIsSelectCardSourceOpen(false);
            void Root_1.queryClient.invalidateQueries({
                queryKey: [paymentQuery_1.paymentKeys.getCompanyCardSources],
            });
        } }, strings_1.cardDetailStrings.CANCEL_BUTTON_TEXT));
    return ((0, jsx_runtime_1.jsxs)(react_1.Suspense, { fallback: (0, jsx_runtime_1.jsx)(pageLoader_1.default, {}), children: [(0, jsx_runtime_1.jsx)(material_1.Paper, { "ts-variant": "container", children: (0, jsx_runtime_1.jsx)(cardsTable_1.default, { isTeamCards: true }) }), (0, jsx_runtime_1.jsx)(footer_1.default, {}), (0, jsx_runtime_1.jsx)(drawerAside_1.default, { id: appConstants_1.sourceCardAsideProperties.SELECT_CARD_SOURCE, title: strings_1.cardDetailStrings.ADD_NEW_CARD_TEXT, open: selectCardSourceAside.isOpen, onClose: () => setIsSelectCardSourceOpen(false), footerButtons: footerButtons, children: (0, jsx_runtime_1.jsx)(material_1.FormGroup, { style: { margin: 1, justifyContent: 'space-between', flex: 1 }, children: renderSelectCardSource() }) }), (0, jsx_runtime_1.jsx)(enrollCardAside_1.default, { submitCardSourceData: submitCardSourceData, asideTitle: globalThis.cardProvider.IS_HSBC_PROVIDER_SETUP
                    ? strings_1.enrollSourceCardStrings.CARD_HEADER_TEXT_HSBC
                    : strings_1.enrollSourceCardStrings.CARD_HEADER_TEXT, hideBackdrop: true }), (0, jsx_runtime_1.jsx)(TeamCardDetailsAside_1.TeamCardDetailsAside, { options: cardOptions, cardAsides: cardAsides, cardSource: cardSource, toggleCard: toggleCard, onRemoveCard: onRemoveCard, setCardAsides: setCardAsides, onSelectTeams: onSelectTeams, onClose: toggleCardDetailsAside, saveConfirmAside: saveConfirmAside, includeRemoveCard: includeRemoveCard, includeSelectTeams: includeSelectTeams, asideId: appConstants_1.sourceCardAsideProperties.CARD_SOURCE_DETAIL, asideTitle: strings_1.cardDetailStrings.CARD_DETAILS_ASIDE_TITLE_TEXT })] }));
};
exports.default = TeamSettingsCardsTemplate;
